"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["transactions"];

function ErrorMessage(_ref) {
  var transactions = _ref.transactions,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var _transactions$0$provi, _transactions$, _transactions$$provid;

    var message = (_transactions$0$provi = transactions === null || transactions === void 0 ? void 0 : (_transactions$ = transactions[0]) === null || _transactions$ === void 0 ? void 0 : (_transactions$$provid = _transactions$['providerData']) === null || _transactions$$provid === void 0 ? void 0 : _transactions$$provid['error']) !== null && _transactions$0$provi !== void 0 ? _transactions$0$provi : null;

    if (message) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['wrapper']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-i'),
        "data-locator": "".concat(props['data-locator'], ".icon")
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['dropdown'],
        "data-locator": "".concat(props['data-locator'], ".dropdown")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['dropdown__label']
      }, message.replace(/\.$/, ''))));
    }

    return null;
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

ErrorMessage.defaultProps = {
  transactions: []
};
var _default = ErrorMessage;
exports["default"] = _default;